import styled from 'styled-components';
import CheggSVG from '../primitives/svg';
import { featureIllustrationIconSizeToPixelValue, featureIllustrationIconSizeToRemValue } from '../shared';

/**
 * Base FeatureIllustrationSvgIcon component
 *
 * Sized using `rem` units. Pixel equivalents in param info.
 *
 * Do not set height & width manually; use `size` instead.
 *
 * @param props.size small (default): 32px, medium: 72px, large: 160px
 */
export var FeatureIllustrationSvgIcon = styled(CheggSVG).attrs(function (props) {
  var pixelValue = featureIllustrationIconSizeToPixelValue[props.size ||
  /* istanbul ignore next */
  'small'];
  return {
    height: pixelValue,
    width: pixelValue
  };
}).withConfig({
  componentId: "sc-91373k-0"
})(["", ""], function (props) {
  var remValue = featureIllustrationIconSizeToRemValue(props.size ||
  /* istanbul ignore next */
  'small');
  return "\n      height: ".concat(remValue, "rem;\n      width: ").concat(remValue, "rem;\n      // without setting min-values, the icons can shrink below desired size when used in flexbox\n      min-height: ").concat(remValue, "rem;\n      min-width: ").concat(remValue, "rem;\n      box-sizing: border-box;\n      overflow: visible; // this is to fix svg cut issue on zoom\n    ");
});
FeatureIllustrationSvgIcon.displayName = 'FeatureIllustrationSvgIcon';
FeatureIllustrationSvgIcon.defaultProps = {
  size: 'small',
  viewBox: '0 0 160 160'
};
export default FeatureIllustrationSvgIcon;